import Booking from './Booking';
import BookingNumberBox from './BookingNumberBox';

export { BookingNumberBox };
export default Booking;
